// ConditionHint.jsx

import React from 'react';

// CSS
import './ConditionHint.css';

/**
 * ConditionHint
 *
 * Renders contextual helper text for condition operators.
 *
 * @param {boolean} showBetweenHint - Whether to show the numeric between hint.
 * @param {boolean} showOlderThanHint - Whether to show the relative date hint.
 * @param {object} theme - Theme object used for dynamic styling.
 *
 * @returns {ReactNode} The rendered condition hint.
 */
const ConditionHint = React.memo(({ showBetweenHint, showOlderThanHint, theme }) => {
  if (!showBetweenHint && !showOlderThanHint) return null;

  // ----- RENDER ----- //

  return (
    <div
      className="automation-modal-condition-hint"
    >
      {showBetweenHint
        ? 'Range is inclusive: min and max are both included.'
        : 'Matches dates older than the selected amount of time.'}
    </div>
  );
});

// Dev Tools
ConditionHint.displayName = 'ConditionHint';

export default ConditionHint;
